import Rate from './rate';
import withFormItem from '../form-item/with';

var MtdRate = withFormItem('MtdRate', Rate);

/* istanbul ignore next */
MtdRate.install = function (Vue) {
  Vue.component(MtdRate.name, MtdRate);
};
export default MtdRate;